import React, { Suspense } from 'react';
import { Navigate, BrowserRouter, Routes, Route } from "react-router-dom";
import { getDefaultChatEntryPath } from '../utils/chatEntryPath.js';

const Chat = React.lazy(() => import("../pages/Chat"));
const ChatPXM = React.lazy(() => import("../pages/PXM_Chat"));
const ChatPX3D = React.lazy(() => import("../pages/PX_3D"));
const Login = React.lazy(() => import("../pages/PXM_Login"));

const loadingFallback = (
    <div style={{ padding: 24, color: '#666', fontSize: 14 }}>加载中…</div>
);

export default function Router() {
    const defaultPath = getDefaultChatEntryPath();
    return (
        <BrowserRouter>
            <Suspense fallback={loadingFallback}>
                <Routes>
                    <Route path="/" element={<Navigate to={defaultPath} replace />} />
                    <Route path="/index.html" element={<Navigate to={defaultPath} replace />} />
                    <Route path="/chatMT" element={<Chat />} />
                    <Route path="/chatYL" element={<Chat />} />
                    <Route path="/chatPX" element={<Chat />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/chatPXM" element={<ChatPXM />} />
                    <Route path="/chatPX3D" element={<ChatPX3D />} />
                    <Route path="*" element={<Navigate to={defaultPath} replace />} />
                </Routes>
            </Suspense>
        </BrowserRouter>
    )
}